<template>
  <div class="_block">
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
              :page-sizes="pageSizes" :page-size='pageSize'
              layout="total, sizes, prev, pager, next, jumper" :total="totalNumber"></el-pagination>
  </div>
</template>

<script>
export default {
  props:{
    totalNumber:{
      type:Number,
      default:0
    },
    pageSizes:{
      type:Array,
      default:()=>{
        return [10,20,40,60]
      }
    },
    parentPageSize:{
      type:Number,
      default:10,
    }
  },
  data(){
    return{
      perPage:1,
      pageSize:this.parentPageSize,
    }
  },
  methods:{
    handleSizeChange(val) {
      this.pageSize = val
      this.$emit("loadTable",this.perPage,this.pageSize);
    },
    handleCurrentChange(val) {
      console.log(this.perPage,'大撒打算弟弟');
      this.perPage = val
      this.$emit("loadTable",this.perPage,this.pageSize);
    },
  }
}
</script>
<style lang="scss" scoped>
._block /deep/ .el-pagination{
  display: flex;
  justify-content: center;
}
</style>